import * as React from "react";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { PensionContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { DocumentsHelper } from "../../../PortfolioDashboard/Components/Document/Resource/DocumentsHelper";
import { DocumentTaskRequestTypeEnum } from "../../../../../../../Wrap/Constants/Enums/Tasks/DocumentTaskRequestTypeEnum";
import { DownloadButton } from "../../../../../../Shared/DownloadButton/DownloadButton";
import { Typography } from "../../../../../../Shared/Typography/Typography";
import { HierarchyIdHelper } from "../../../../../../Shared/Common/HierarchyIdHelper";

interface IDocumentsProps extends IProcessComponentProps {
    data: PensionContributionModel;
}

interface IDocumentsState {}

export class Documents extends ProcessComponent<IDocumentsProps, IDocumentsState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        return (
            <>
                <div>
                    {this.renderDocuments()}
                </div>
            </>
        );
    }

    private renderDocuments() {
        const claccountid = getQueryParameters()["claccountid"];
        const headAccountHierarchyId = getQueryParameters()["hierarchyid"];
        const benefitCrystallisationIllustrationQuery = DocumentsHelper.getTaskRequestForBenefitCrystallisationIllustration(
            HierarchyIdHelper.generateHierarchyId(this.props.data?.Contribution?.HierarchyId).entityId,
            claccountid,
            DocumentTaskRequestTypeEnum.BenefitCrystallisationIllustration
        );
        
        let config = [
            {
                title: (
                    <div className="mb-24">
                        <a className="hyperlink">Benefit Crystallisation Illustration</a>
                        <DownloadButton
                            request={benefitCrystallisationIllustrationQuery}
                            selectedAccount={headAccountHierarchyId}
                        ></DownloadButton>
                    </div>
                ),
                data: " ",
            },
        ];
        return (
            <>
                <Typography type="wider" wrapCss="narrow-margin no-print" config={config}></Typography>
            </>
        );
    }
}
